export const state_patcher = (state, action) => {
    // This is specific to reduxjs/toolkit slice dispatchers
    // Normal redux dispatchers have different signature.

    // const old_state = current(state)
    const patch = action.payload

    // wish this was regular reducer so I could just return
    // return {...old_state, ...patch}
    // instead we have to do this:
    for (var key in patch) {
        state[key] = patch[key]
    }
}
